import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'

import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createUploadLink } from 'apollo-upload-client/lib/main'
import { ApolloLink, Observable } from 'apollo-link'
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import introspectionQueryResultData from './fragmentTypes.json'

import App from 'components/App'

import 'semantic-ui-css/semantic.min.css'

const uri =
  process.env.REACT_APP_STAGE === 'local'
    ? 'http://localhost:3500/graphql'
    : '/graphql'

const request = async operation => {
  const token = await localStorage.getItem('token')
  operation.setContext({
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  })
}

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) handle.unsubscribe()
      }
    })
)

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
})
const cache = new InMemoryCache({ fragmentMatcher })

const client = new ApolloClient({
  link: ApolloLink.from([requestLink, createUploadLink({ uri })]),
  cache
})

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js